import DorasIcons from "@/lib/DorasIcons";
import { isUUID } from "@/lib/utils";
import * as tabler from "@tabler/icons-react";

const RenderIconOrAsset = ({
    account_id,
    iconName,
    size,
    raw,
}: {
    account_id: string;
    iconName: string;
    size?: number;
    raw?: boolean;
}) => {
    try {
        if (iconName.startsWith("Icon")) {
            //@ts-expect-error
            const IconComponent = tabler[iconName];
            // Ensure it's a valid React component (function or forwardRef)
            if (
                typeof IconComponent === "function" ||
                (typeof IconComponent === "object" &&
                    IconComponent?.$$typeof === Symbol.for("react.forward_ref"))
            ) {
                if (raw) {
                    return <IconComponent size={size || 60} />;
                }
                return (
                    <div
                        className={
                            "absolute left-4 top-1/2 -translate-y-1/2 transform"
                        }
                    >
                        <IconComponent size={size || 60} />
                    </div>
                );
            } else {
                console.warn(
                    `Skipping invalid component: ${iconName}`,
                    IconComponent
                );
                return null;
            }
        } else if (iconName.startsWith("Doras")) {
            let icon_item = DorasIcons.find((i) => i.value == iconName);
            if (icon_item) {
                if (raw) {
                    return (
                        <img
                            src={icon_item.img}
                            alt="custom icons"
                            style={{ width: size || 60, height: size || 60 }}
                        />
                    );
                }
                return (
                    <img
                        src={icon_item.img}
                        className={
                            "absolute left-4 top-1/2 -translate-y-1/2 transform"
                        }
                        alt="custom icons"
                        style={{ width: size || 60, height: size || 60 }}
                    />
                );
            }
        } else if (isUUID(iconName)) {
            const img =
                "https://cdn.doras.to/doras/assets/" +
                account_id +
                "/" +
                iconName;
            if (raw) {
                return (
                    <img
                        src={img}
                        alt="custom icons"
                        style={{ width: size || 60, height: size || 60 }}
                    />
                );
            }
            return (
                <img
                    src={img}
                    className={
                        "absolute left-4 top-1/2 -translate-y-1/2 transform rounded-sm object-cover p-[1px]"
                    }
                    alt="custom icons"
                    id="block-icon"
                    style={{ width: size || 60, height: size || 60 }}
                />
            );
        }
    } catch (error) {
        console.error(`Error rendering icon "${iconName}":`, error);
        return null;
    }
};
export default RenderIconOrAsset;
